<style lang="scss" scoped="scoped">
	::-webkit-scrollbar {
		display: none;
	}
</style>
<style lang="scss">

</style>
<template>
	<div style="width: 100%;">
		<div class="titleBar" style="display: flex;margin-top: 20px;align-items:center ;">
			<span style="width: 5px;height: 16px;background: #419FFF;margin-right:12px ;"></span>
			<p style="font-size: 16px;line-height: 22px;color: #303133;">
				{{$t('shujupeizhi')}}
			</p>
		</div>
		<div style="margin-top: 12px;">
			<el-form ref="form" label-width="auto">
				<el-form-item :label="$t('wangongyuceshijian')">
					<el-input-number size="small" v-model="monitorSetting.PREPARE_PLAN_HOUR">
					</el-input-number><span style="margin-left:10px">{{$t('xiaoshi')}}</span>
				</el-form-item>
			</el-form>
		</div>
		<div class="titleBar" style="display: flex;margin-top: 20px;align-items:center ;">
			<span style="width: 5px;height: 16px;background: #419FFF;margin-right:12px ;"></span>
			<p style="font-size: 16px;line-height: 22px;color: #303133;">
				{{$t('ziduanpeizhi')}}
			</p>
		</div>
		<div style="display: flex;width: 100%;justify-content: center;height: 320px;margin-top: 20px;">
			<el-transfer target-order="push" style="text-align: left; display: inline-block"
				v-model="monitorSetting.PREPARE_COLUMNS" :titles="[$t('yincanglie'), $t('xianshilie')]" :format="{
		  noChecked: '${total}',
		  hasChecked: '${checked}/${total}'
		}" @change="showColumnsChange" :data="allColumns">
				<div slot-scope="{ option }" style="display: flex;justify-content: space-between;width: 100%;">
					<div>{{$t(option.label) }}</div>
					<div>
						<!-- <i @click="columnUp($event,option.label)" class="el-icon-bottom" style="font-size: 14px;"></i> -->
					</div>
				</div>

			</el-transfer>

		</div>

		<div class="titleBar" style="display: flex;margin-top: 20px;align-items:center ;">
			<span style="width: 5px;height: 16px;background: #419FFF;margin-right:12px ;"></span>
			<p style="font-size: 16px;line-height: 22px;color: #303133;">
				{{$t('zitipeizhi')}}(px)
			</p>
		</div>
		<div style="margin-top: 12px;">
			<el-form ref="form" label-width="auto">
				<el-form-item :label="$t('dangqianshengchanbiaoti')">
					<el-input-number size="small" v-model="monitorSetting.PREPARE_CURRENT_ORDER_TITLE_SIZE">
					</el-input-number>
				</el-form-item>
				<el-form-item :label="$t('dangqianshengchanneirong')">
					<el-input-number size="small" v-model="monitorSetting.PREPARE_CURRENT_ORDER_CONTENT_SIZE">
					</el-input-number>
				</el-form-item>
				<el-form-item :label="$t('daichangongdanbiaoti')">
					<el-input-number size="small" v-model="monitorSetting.PREPARE_WAITING_ORDER_TITLE_SIZE">
					</el-input-number>
				</el-form-item>
				<el-form-item :label="$t('daichangongdanneirong')">
					<el-input-number size="small" v-model="monitorSetting.PREPARE_WAITING_ORDER_CONTENT_SIZE">
					</el-input-number>
				</el-form-item>
				<el-form-item :label="$t('lingliaoxinxibiaoti')">
					<el-input-number size="small" v-model="monitorSetting.PREPARE_MODULE_TITLE_SIZE"></el-input-number>
				</el-form-item>
				<el-form-item :label="$t('lingliaoxinxineirong')">
					<el-input-number size="small" v-model="monitorSetting.PREPARE_MODULE_CONTENT_SIZE">
					</el-input-number>
				</el-form-item>
			</el-form>
		</div>


	</div>
</template>
<script type="text/javascript">
	export default {
		name: 'web_monitor_prepare_setting',
		components: {

		},

		data() {
			return {
				monitorSetting: {},
				allColumns: [{
						key: 'shengchangongdanhao',
						label: this.$t('shengchangongdanhao'),
						disabled: true,
					},
					{
						key: 'chanpinmingcheng',
						label: this.$t('chanpinmingcheng'),
						disabled: false,
					},
					{
						key: 'liaohao',
						label: this.$t('liaohao'),
						disabled: false,
					},
					{
						key: 'mojubianhao',
						label: this.$t('mojubianhao'),
						disabled: false,
					},
					{
						key: 'mojumingcheng',
						label: this.$t('mojumingcheng'),
						disabled: false,
					},
					{
						key: 'gongdanshunxu',
						label: this.$t('gongdanshunxu'),
						disabled: false,
					},
					{
						key: 'jihuakaishishijian',
						label: this.$t('jihuakaishishijian'),
						disabled: false,
					},
					{
						key: 'huanmozhuangtai',
						label: this.$t('huanmozhuangtai'),
						disabled: false,
					},
					{
						key: 'beiliaozhuangtai',
						label: this.$t('beiliaozhuangtai'),
						disabled: false,
					},

				]
			};
		},
		created() {
			this.resetData()
		},
		activated() {
			this.resize()
		},
		mounted() {
			this.resize()
			this.utils.event_hub.$on('RESIZE', () => {
				this.resize();
			});
		},
		destroyed() {},
		methods: {
			showColumnsChange(e) {
				console.log(e)
				let index = e.indexOf('beizhu')
				if (index > 0) {
					e.splice(index, 1)
					e.push('beizhu')
				}
				//如果有备注，把备注放最后
				//保存
				//window.localStorage.setItem("column_" + this.name, JSON.stringify(this.showColumns))
			},
			resetData() {
				//可能要防到mainjs里面去初始化,因为看板拿配置的时候setting弹框还没打开
				let monitorSetting = localStorage.getItem("MONITOR_SETTING")
				if (!monitorSetting) {
					this.monitorSetting = {}
				} else {
					this.monitorSetting = JSON.parse(monitorSetting)
				}




				this.monitorSetting.PREPARE_PLAN_HOUR = this.monitorSetting.PREPARE_PLAN_HOUR !=
					null ?
					this.monitorSetting.PREPARE_PLAN_HOUR : 12

				this.monitorSetting.PREPARE_COLUMNS = this.monitorSetting.PREPARE_COLUMNS !=
					null ?
					this.monitorSetting.PREPARE_COLUMNS : ["shengchangongdanhao", "chanpinmingcheng",
						"liaohao", "mojubianhao", "mojumingcheng", "gongdanshunxu", "jihuakaishishijian",
						"huanmozhuangtai", "beiliaozhuangtai"
					]

				this.monitorSetting.PREPARE_CURRENT_ORDER_TITLE_SIZE = this.monitorSetting
					.PREPARE_CURRENT_ORDER_TITLE_SIZE !=
					null ?
					this.monitorSetting.PREPARE_CURRENT_ORDER_TITLE_SIZE : 14

				this.monitorSetting.PREPARE_CURRENT_ORDER_CONTENT_SIZE = this.monitorSetting
					.PREPARE_CURRENT_ORDER_CONTENT_SIZE !=
					null ?
					this.monitorSetting.PREPARE_CURRENT_ORDER_CONTENT_SIZE : 16

				this.monitorSetting.PREPARE_WAITING_ORDER_TITLE_SIZE = this.monitorSetting
					.PREPARE_WAITING_ORDER_TITLE_SIZE !=
					null ?
					this.monitorSetting.PREPARE_WAITING_ORDER_TITLE_SIZE : 14

				this.monitorSetting.PREPARE_WAITING_ORDER_CONTENT_SIZE = this.monitorSetting
					.PREPARE_WAITING_ORDER_CONTENT_SIZE !=
					null ?
					this.monitorSetting.PREPARE_WAITING_ORDER_CONTENT_SIZE : 16

				this.monitorSetting.PREPARE_MODULE_TITLE_SIZE = this.monitorSetting.PREPARE_MODULE_TITLE_SIZE !=
					null ?
					this.monitorSetting.PREPARE_MODULE_TITLE_SIZE : 14

				this.monitorSetting.PREPARE_MODULE_CONTENT_SIZE = this.monitorSetting.PREPARE_MODULE_CONTENT_SIZE !=
					null ?
					this.monitorSetting.PREPARE_MODULE_CONTENT_SIZE : 16


				localStorage.setItem("MONITOR_SETTING", JSON.stringify(this.monitorSetting))

			},
			resize() {
				//因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
				setTimeout(() => {

				}, 500)
			},
			save() {

				localStorage.setItem("MONITOR_SETTING", JSON.stringify(this.monitorSetting))

				this.utils.event_hub.$emit('SetPrepare')
			}

		}
	};
</script>
